import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useErrorBoundary } from 'react-error-boundary';
import { sha256 } from 'js-sha256';

const BuyIndexContainer = ({ buy }) => {
  const { showBoundary } = useErrorBoundary();

  const clearDataAndRedirectToStripe = (url) => {
    global.localStorage.removeItem('buyProductId');
    global.localStorage.removeItem('buyPromoCode');
    global.localStorage.removeItem('buySource');

    setTimeout(() => {
      window.location = url;
    }, 1000);
  };

  const isPast48Hours = (created) => {
    const now = new Date();
    const userCreatedDate = new Date(created);
    const timeDifference = +now - +userCreatedDate;

    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference >= 48;
  };

  const handleBuy = async () => {
    const productVariantId = +global.localStorage.getItem('buyProductId');
    let cancelUrl = (global.localStorage.getItem('buyFromLandinng') || '').replaceAll('|', '&');
    const promoCode = global.localStorage.getItem('buyPromoCode');
    const source = global.localStorage.getItem('buySource');

    const productPrice = global.localStorage.getItem('buyProductPrice');

    const userEmail = global.localStorage.getItem('userEmail') || '';
    const userId = global.localStorage.getItem('userId') || '';
    const userCreated = global.localStorage.getItem('userCreated') || '';

    console.log('userEmail from BuyIndexContainer:', userEmail);
    console.log('userId from BuyIndexContainer:', userId);

    if (productVariantId && cancelUrl) {
      if (window) {
        // Clear the previous ecommerce object.
        window.dataLayer.push({ ecommerce: null });

        const dataLayerObject = {
          event: 'begin_checkout',
          email: userEmail,
          sha256_email: sha256(userEmail),
          new_customer: !isPast48Hours(userCreated),
          ecommerce: {
            currency: 'USD',
            items: [
              {
                item_id: productVariantId,
                price: productPrice,
              },
            ],
          },
          user_data: {
            email: userEmail,
            user_id: userId,
          },
        };

        window.dataLayer.push(dataLayerObject);
      }

      let request = {
        productVariantId,
        successUrl: `${import.meta.env.VITE_REACT_APP_URL}/buy/thank-you/%PAYMENT_TOKEN%`,
        cancelUrl,
      };

      if (promoCode) {
        request.promoCode = promoCode;
      }

      if (source) {
        request.source = source;
      }

      try {
        const response = await buy(request);
        const { __typename, url, paymentWithoutPromotionCode } =
          response.data.sale.createSubscription;

        if (__typename === 'Payment') {
          clearDataAndRedirectToStripe(url);
        } else if (__typename === 'SubscriptionCreateException') {
          showBoundary();
          throw new Error(`Failed to create subscriprion, SubscriptionCreateException`);
        } else if (__typename === 'ValidationException') {
          showBoundary();
          throw new Error(`Failed to create subscriprion, ValidationException`);
        } else if (__typename === 'UnauthorizedException') {
          showBoundary();
          throw new Error(`Failed to create subscriprion, UnauthorizedException`);
        } else if (__typename === 'InvalidPromoCodeException') {
          if (paymentWithoutPromotionCode.__typename === 'Payment') {
            clearDataAndRedirectToStripe(paymentWithoutPromotionCode.url);
          } else if (paymentWithoutPromotionCode.__typename === 'SubscriptionCreateException') {
            showBoundary();
            throw new Error(`Failed to create subscriprion, SubscriptionCreateException`);
          }
        }
      } catch (e) {
        showBoundary(e);
        throw new Error(`Failed to create subscriprion, got error: ${e}`);
      }
    }
  };

  useEffect(() => {
    const cancelUrl = global.localStorage.getItem('buyFromLandinng').replaceAll('|', '&');
    if (!global.localStorage.getItem('buyProductId')) {
      global.localStorage.removeItem('buyFromLandinng');

      window.location = cancelUrl ? cancelUrl : import.meta.env.VITE_LANDING_PAGE_URL;
    }

    handleBuy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

BuyIndexContainer.propTypes = {
  buy: PropTypes.func.isRequired,
};

export default BuyIndexContainer;
